import { render, staticRenderFns } from "./topSalesByKaresidenan.vue?vue&type=template&id=18c625d3"
import script from "./topSalesByKaresidenan.vue?vue&type=script&lang=js"
export * from "./topSalesByKaresidenan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports